<template>
  <div class="app">
    <v-sheet v-show="showSkeleton" class="pa-3">
      <v-row>
        <v-col v-for="item in 2" :key="item" cols="2">
          <v-skeleton-loader class="mx-auto" type="button" />
        </v-col>
      </v-row>
      <v-row>
        <v-col v-for="item in 3" :key="item">
          <v-skeleton-loader class="mx-auto" type="list-item" />
        </v-col>
      </v-row>
      <v-row>
        <v-col v-for="item in 3" :key="item">
          <v-skeleton-loader class="mx-auto" type="list-item" />
        </v-col>
      </v-row>
    </v-sheet>
    <v-form ref="form" v-show="!showSkeleton">
      <v-row dense>
        <v-col cols="3">
          <v-text-field
            dense
            v-model="form.acao.description"
            :counter="35"
            label="Descrição"
            :error-messages="descriptionErrors"
            @input="$v.form.acao.description.$touch()"
            @blur="$v.form.acao.description.$touch()"
          />
        </v-col>
        <v-col class="ml-14" cols="2">
          <v-switch dense v-model="form.active" label="Ativo" />
        </v-col>
        <v-col cols="3">
          <v-switch dense v-model="form.acao.continuar" label="Executar Próxima Ação Válida" />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-row>
            <v-col>
              <v-text-field
                dense
                v-model="form.regexVisualOrigem"
                :counter="20"
                label="Expressão de Origem"
                :error-messages="regexVisualOrigemErrors"
                @input="
                  $v.form.regexVisualOrigem.$touch()
                  form.regexVisualOrigem = $event.trim()
                "
                @blur="$v.form.regexVisualOrigem.$touch()"
              />
            </v-col>
            <v-col>
              <v-text-field
                dense
                v-model="form.regexVisualDestino"
                :error-messages="regexVisualDestinoErrors"
                :counter="20"
                label="Expressão de Destino"
                @input="
                  $v.form.regexVisualDestino.$touch()
                  form.regexVisualDestino = $event.trim()
                "
                @blur="$v.form.regexVisualDestino.$touch()"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-select
                dense
                v-model="form.alliasRegexOrigem"
                label="Grupos de Expressões Origem"
                :items="alliasRegexOrigem"
              />
            </v-col>
            <v-col>
              <v-select
                dense
                v-model="form.alliasRegexDestino"
                label="Grupos de Expressões Destino"
                :items="alliasRegexDestino"
              />
            </v-col>
          </v-row>
        </v-col>
        <v-col>
          <v-row>
            <v-col cols="6">
              <v-select
                dense
                v-model="form.acao.centroDeCusto"
                :error-messages="centroDeCustoErrors"
                :items="centroDeCusto"
                label="Centro de Custo"
                @input="$v.form.acao.centroDeCusto.$touch()"
                @blur="$v.form.acao.centroDeCusto.$touch()"
              />
            </v-col>
            <v-col cols="6">
              <v-select dense multiple v-model="form.acao.tag" :items="tags" label="Tags">
                <template v-slot:selection="{ item, index }">
                  <span v-if="index === 0">{{ item.text }}</span>
                  <v-chip v-if="index === 1" small>
                    <span class="caption"> (+{{ form.acao.tag.length - 1 }}) </span>
                  </v-chip>
                </template>
                <template v-slot:prepend-item>
                  <v-list-item ripple @click="toggleTags">
                    <v-list-item-action>
                      <v-icon :color="form.acao.tag.length > 0 ? 'indigo darken-4' : ''">
                        {{ iconTags }}
                      </v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>
                        Selecionar Todas
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="mt-2" />
                </template>
              </v-select>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-select
            v-model="choicedGroups"
            :items="gruposDeRotas"
            multiple
            dense
            label="Grupos de rotas"
            @change="eventChange"
            :error-messages="choicedGroupsErrors"
          >
            <template v-slot:selection="{ item, index }" >
              <span v-if="index === 0">{{ item.text }}</span>
              <v-chip v-if="index === 1" small>
                <span class="caption"> (+{{ choicedGroups.length - 1 }}) </span>
              </v-chip>
            </template>
            <template v-slot:prepend-item>
              <v-list-item ripple @click="toggle">
                <v-list-item-action>
                  <v-icon :color="choicedGroups.length > 0 ? 'indigo darken-4' : ''">
                    {{ icon }}
                  </v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    Selecionar Todos
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="mt-2" />
            </template>
          </v-select>
        </v-col>
        <v-col cols="4">
          <v-select
            dense
            v-model="form.acao.rota_id"
            v-show="choicedGroups.length > 0"
            :error-messages="rotaErrors"
            :items="filtredItens"
            label="Rota"
            @input="$v.form.acao.rota_id.$touch()"
            @blur="$v.form.acao.rota_id.$touch()"
          />
        </v-col>
        <v-col cols="4">
          <v-select
            dense
            v-show="form.acao.rota_id && choicedGroups.length > 0"
            v-model="form.acao.regex_id"
            :error-messages="regexIdErrors"
            :items="buscaRegex"
            label="Ação da Rota"
            @input="$v.form.acao.regex_id.$touch()"
            @blur="$v.form.acao.regex_id.$touch()"
          />
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { mapActions, mapGetters } from 'vuex'

import { registerVuexModule } from '@/utils/vuexUtils'

import { rotasMixin } from '../_mixins/rotasMixins'
import { ativarDesativarAcaoMixins } from '../_mixins/ativarDesativarAcaoMixins'


import RotaStore from '../_store'

export default {
  name: 'AtivarRegex',
  mixins: [validationMixin, rotasMixin, ativarDesativarAcaoMixins],
  data: () => ({
    choicedGroups: [],
    gruposDeRotas: [],
    allRoutes: [],
    form: {
      description: 'ATIVAR AÇÃO',
      regexVisualOrigem: '',
      regexVisualDestino: '',
      alliasRegexOrigem: '',
      alliasRegexDestino: '',
      active: true,
      acao: {
        description: 'ATIVAR AÇÃO',
        class: 'Modules\\Agi\\Entities\\acoes\\ChangeToTrueActiveRegex',
        centroDeCusto: '',
        tag: [],
        rota_id: '',
        regex_id: '',
        continuar: false,
      },
    },
  }),
  computed: {
    ...mapGetters('acaoAtivarRegraRotasModulePABXStore', ['getRotas', 'getGrupos']),
    todosGruposSelecionados() {
      return this.choicedGroups.length === this.gruposDeRotas.length
    },
    algunsGruposSelecionados() {
      return this.choicedGroups.length > 0 && !this.todosGruposSelecionados
    },
    icon() {
      if (this.todosGruposSelecionados) return 'mdi-close-box'
      if (this.algunsGruposSelecionados) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
  },
  async created() {
    registerVuexModule(this.$store, 'acaoAtivarRegraRotasModulePABXStore', RotaStore)

    await Promise.all([this.listarRotas(), this.listarCentroDeCustos(), this.listarRegex(), this.listarTags(), this.listarGruposRotas()])

    this.rotasParaMontarRegex = [...this.getRotas]


    this.allRoutes = [...this.getRotas]

    this.getItemsSelectRotas()
    this.getItemsSelectCentroDeCusto()
    this.getItemsSelectRegexOrigemEDestino()
    this.getItemsSelectTags()
    
    this.makeFormulario()

    this.gruposDeRotas = this.getGrupos.map(grupo => ({ text: grupo.description, value: grupo._id }))

    if(this.form.acao.rota_id !== '') {
      let route = this.allRoutes.find(element => element._id === this.form.acao.rota_id)
      let groups = this.gruposDeRotas.map(grupo => grupo.value)
      this.choicedGroups.push(groups.find(element => element === route.group))
      this.filtrar()
    }
    
    this.showSkeleton = false
  },
  methods: {
    ...mapActions('acaoAtivarRegraRotasModulePABXStore', ['listarRotas', 'listarGruposRotas']),
    zerar() {
      this.form.acao.rota_id = ''
      this.form.acao.regex_id = ''
    },
    zerarRegex() {
      this.form.acao.regex_id = ''
    },
    filtrar() {
      this.filtredItens = []
      this.allRoutes.forEach(rota => {
        if(this.choicedGroups.includes(rota.group)) {
          this.filtredItens.push(this.rotas.find(element => element.value === rota._id))
        }
      })
    },
    eventChange() {
      this.zerar()
      this.zerarRegex()
      this.filtrar()
    },
    toggle() {
      this.$nextTick(() => {
        if (this.todosGruposSelecionados) {
          this.choicedGroups.splice(0)
        } else {
          this.choicedGroups.splice(0)
          this.choicedGroups = this.gruposDeRotas.map(grupo => grupo.value)
        }
        this.filtrar()
      })
    },
  },
}
</script>

<style scoped>
.app {
  background-color: var(--v-background-base);
}
</style>
